import React, { useEffect, useState } from 'react';
import { StatusConfigGroup, StatusConfig } from './types';
import { IGetStudentPaginatedRosterData } from '../../../apollo/types';
import Spinner from '../../ui/loading/SpinnerWrapper';
import './StatsBar.scss';

import StatsCard from './StatsCard';

interface StatsBarProps {
  students_status: IGetStudentPaginatedRosterData[];
  status_config_groups: StatusConfigGroup[];
  active?: boolean;
  onClick: (id: string) => void;
  filterId: string | null;
  lastKey: string | null | undefined;
}

/**
 * Returns the length for each config 'filter'. If loading is in progress, use cache lengths instead.
 *
 */
function getContentLength(
  loading: boolean,
  config: StatusConfig,
  students_status: IGetStudentPaginatedRosterData[],
  configCountCache: { [key: string]: number }
): number {
  if (loading && config.id in configCountCache) {
    return configCountCache[config.id] || 0;
  }
  return config.filter(students_status).length;
}

interface StatsBarState {
  initial_loading_done: boolean;
  configCountCache: { [key: string]: number };
}

export default function StatsBar({ lastKey, students_status, status_config_groups, filterId, onClick }: StatsBarProps) {
  const [statsBarState, setStatsBarState] = useState<StatsBarState>({
    initial_loading_done: false,
    configCountCache: {},
  });

  useEffect(() => {
    if (lastKey === null) {
      const copyState = { ...statsBarState, initial_loading_done: true };
      status_config_groups.map((status_config) => {
        status_config.group.forEach((config) => {
          statsBarState.configCountCache[config.id] = config.filter(students_status).length;
        });
      });
      // eslint-disable-next-line
      setStatsBarState(copyState);
    }
    // eslint-disable-next-line
  }, [lastKey]);

  if (!statsBarState.initial_loading_done) {
    return <Spinner />;
  }

  return (
    <div className='tdtk-stats-bar pb-3'>
      {status_config_groups.map((status_config) => {
        return status_config.group.map((config, index) => {
          return (
            statsBarState.initial_loading_done && (
              <React.Fragment key={config.id}>
                <div className='tdtk-stats-card-wrapper mx-1' key={`card-${config.id}`}>
                  <StatsCard
                    id={config.id}
                    content={getContentLength(
                      Boolean(lastKey),
                      config,
                      students_status,
                      statsBarState.configCountCache
                    )}
                    footer={config.footer}
                    active={filterId === config.id}
                    onClick={() => {
                      onClick(config.id);
                    }}
                  />
                </div>
                {status_config.divider && status_config.group.length - 1 === index && (
                  <div className='tdtk-stats-divider' key={`divider-${config.id}`}></div>
                )}
              </React.Fragment>
            )
          );
        });
      })}
    </div>
  );
}
